import { BCancellationFeeTypeEnum } from '@/types/backend';
import { BPaymentBehaviourEnum } from '@/types/temp';
import { FPaymentModeEnum, FTunnelPageBookingTypeEnum } from '@/types/tunnel';
import { COLON_TIME_FORMAT, DATE_FORMAT, DATE_TIME_FORMAT } from '@winelidays/wld-tsx-2/constants';
import { formatDate, isBeforeDate, isValidDate, parseDate, subtractHoursFromDate } from '@winelidays/wld-tsx-2/utils';
import getGTMItem from './getGTMItem';
const getGTMECommerce = ({ experience, bookingType, discount, paymentBehaviour, totalPrice, conversionAmount, reservationInProgress, currencyKey }) => {
    const hasPayment = paymentBehaviour?.includes(BPaymentBehaviourEnum.Checkout) || paymentBehaviour?.includes(BPaymentBehaviourEnum.TakeBankImprint);
    /* start data layer object */
    const newDataLayer = {
        has_online_payment: hasPayment,
        tunnel_mode: hasPayment ? FPaymentModeEnum.ONLINE : 'offline',
        experience_id: experience?.identifier ?? 0,
        total_price: totalPrice ?? undefined,
        nb_adults: undefined,
        nb_children: undefined,
        booking_language: undefined,
        booking_date: undefined,
        booking_time: undefined,
        not_refundable: bookingType === FTunnelPageBookingTypeEnum.voucher,
        items: [],
        currency: currencyKey,
        value: conversionAmount ?? undefined,
        coupon: discount?.totalDiscount ? discount?.discountCode : undefined
    };
    if (reservationInProgress) {
        newDataLayer.nb_adults = reservationInProgress.remainingStock.adults;
        newDataLayer.nb_children = reservationInProgress.remainingStock.children ? reservationInProgress.remainingStock.children.length : 0;
        newDataLayer.booking_language = reservationInProgress.lang ?? undefined;
        let date, time;
        if (reservationInProgress.dateTime) {
            const dateTime = parseDate(reservationInProgress.dateTime, DATE_TIME_FORMAT);
            if (isValidDate(dateTime)) {
                date = formatDate(dateTime, DATE_FORMAT);
                time = formatDate(dateTime, COLON_TIME_FORMAT);
            }
        }
        newDataLayer.booking_date = date;
        newDataLayer.booking_time = time;
        // Check if non refundable
        if (totalPrice != null && totalPrice > 0 &&
            // has payment
            reservationInProgress.dateTime &&
            // has experience dateTime
            !!experience?.cancellation.fees?.value && (
        // has cancellation fees
        experience?.cancellation.fees?.type === BCancellationFeeTypeEnum.Percent ? experience?.cancellation.fees?.value === 100 : experience?.cancellation.fees?.value >= totalPrice) // cancellation fees cover the totalPrice
        ) {
            let deadlineDate = parseDate(reservationInProgress.dateTime, DATE_TIME_FORMAT);
            if (experience?.cancellation.deadline) {
                deadlineDate = subtractHoursFromDate(deadlineDate, experience?.cancellation.deadline);
            }
            newDataLayer.not_refundable = !!deadlineDate && isBeforeDate(deadlineDate);
        }
    }
    newDataLayer.items = [getGTMItem({
            experience,
            bookingType,
            nbAdults: newDataLayer.nb_adults ?? null,
            bookingLanguage: newDataLayer.booking_language ?? null,
            discountAmount: discount?.totalDiscount ?? null
        })];
    return newDataLayer;
};
export default getGTMECommerce;
